import styled from 'styled-components';

export const Wrapper = styled.div`
    max-width: 500px;
    margin-top: 12px;

    .error-message {
        color: ${props => props.theme.error};
    }

    #cardAccordionButton {
        display: none;
    }
    .f1h4br2g {
        padding: 0;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-step/checkout-flow/CheckoutStyle.js